import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Translate, I18n } from 'react-redux-i18n'
import { Field, reduxForm } from 'redux-form'
import Grid from 'material-ui/Grid'

import { signIn } from 'modules/users/sessions'
import { getUriBase } from 'modules/users/unlocks'
import ValidationErrors from '../validation_errors'
import Group from '../group'
import Submit from '../submit'
import parametersSelector from 'selectors/parameters'
import errorsSelector from 'selectors/errors'

const SignInForm = ({ pristine, reset, submitting, handleSubmit, config_parameters, errors }) => (
  <form onSubmit={handleSubmit}>
    <ValidationErrors errors={errors} />
    <br />
    <Grid container direction="column">
      <Grid item>
        <Field
          name="email"
          type="email"
          component={Group}
          label={I18n.t('users.common.email')}
          required
        />
      </Grid>
      <Grid item>
        <Field
          name="password"
          type="password"
          component={Group}
          label={I18n.t('users.common.password')}
          required
        />
      </Grid>
      <Grid item>
        <br />
        <div className="text-center">
          <div>
            <Submit
              className="btn-card-login-submit"
              value={I18n.t('users.sign_in.submit')}
              disabled={pristine || submitting}
            />
          </div>
          <br />
          <p>
            <Link to="/users/password/new">
              <Translate value="users.sign_in.remind" />
            </Link>
          </p>
          <p>
            <Link to="/users/confirmation">
              <Translate value="users.sign_in.instructions" />
            </Link>
          </p>
        </div>
      </Grid>
    </Grid>
  </form>
)

const SignInFormContainer = ({ config_parameters }) => (
  <div className="short-form">
    <h2>
      <Translate value="users.sign_in.h" />
    </h2>
    {config_parameters['ico_enabled'] && (
      <p className="text-center">
        <Translate value="users.sign_in.not_registered" />{' '}
        <Link to="/users/sign_up">
          <b>{I18n.t('users.common.sign_up')}</b>
        </Link>
      </p>
    )}
    <br />
    {!config_parameters['ico_enabled'] && (
      <div className="alert alert-dismissible alert-danger">
        <center>The ICO is closed</center>
      </div>
    )}
    <ReduxForm />
  </div>
)

const mapStateToProps = state => ({
  config_parameters: parametersSelector(state),
  errors: errorsSelector('users.sign_in', 'validation_error')(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ signIn }, dispatch)

const ReduxForm = connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'sign_in',
    onSubmit: (props, dispatch, { signIn }) =>
      signIn({ ...props, unlock_uri: getUriBase(window.location) }),
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(SignInForm)
)

export default connect(mapStateToProps, mapDispatchToProps)(SignInFormContainer)



// WEBPACK FOOTER //
// ./src/containers/pages/users/sign_in/form.js